import { Cell } from '@pelckmans/elementis/components/table/cell';
import { ComponentProps } from 'react';
import { formatPercentage } from '@pelckmans/elementis/components/results';

export default function PercentageCell({
  achieved,
  maximum,
  needsGrading,
  highlighted,
}: {
  achieved?: number;
  maximum?: number;
  needsGrading?: boolean;
} & Pick<ComponentProps<typeof Cell>, 'highlighted'>) {
  return achieved === undefined || maximum === undefined || needsGrading ? (
    <Cell minWidth="xs" maxWidth="xs" highlighted={highlighted} />
  ) : (
    <Cell minWidth="xs" maxWidth="xs" highlighted={highlighted}>
      <Cell.Text title={formatPercentage({ achieved, maximum })} />
    </Cell>
  );
}
